const contactTabsArr = document.querySelectorAll('.contact-sec__tab');
const contactItemsArr = document.querySelectorAll('.contact-sec__item');

if (contactTabsArr.length > 0 && contactItemsArr.length > 0) {
  contactTabsArr.forEach((contactTab, idx) => {
    contactTab.addEventListener('click', () => {
      for (let i = 0; i < contactTabsArr.length; i++) {
        contactTabsArr[i].classList.remove('is-active');
        contactItemsArr[i].classList.remove('is-active');
      }
      contactTab.classList.add('is-active');
      contactItemsArr[idx].classList.add('is-active');
    });
  });
} else if(contactTabsArr.length > 0) {
  contactTabsArr.forEach((contactTab) => {
    contactTab.addEventListener('click', () => {
      contactTabsArr.forEach(t => t.classList.remove('is-active'));
      contactTab.classList.add('is-active');
    });
  });
}
